import * as React from "react";
import PropTypes from "prop-types";
import MuiTooltip from "@mui/material/Tooltip";
import ClickAwayListener from "@mui/material/ClickAwayListener";

const propTypes = {
  content: PropTypes.object.isRequired,
  tooltip: PropTypes.object.isRequired,
};
Tooltip.prototype = propTypes;
export default function Tooltip(props) {
  const [open, setOpen] = React.useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <MuiTooltip
        PopperProps={{
          disablePortal: true,
        }}
        onClose={handleTooltipClose}
        open={open}
        disableFocusListener
        title={props.content}
        onClick={handleTooltipOpen}
        sx={{ m: 0 }}
      >
        {props.tooltip}
      </MuiTooltip>
    </ClickAwayListener>
  );
}
